import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';
import { AccountInfo } from '@azure/msal-browser';
import { AccountInfoService } from '../../../../services/account-info.service';
import { SettingsComponent } from '../../../settings/settings.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-navbar',
    imports: [RouterLink, RouterModule, CommonModule, SettingsComponent],
    templateUrl: './navbar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit, OnDestroy {
  currentUser: AccountInfo | undefined;
  photoUrl: string | null = null;

  private _destroy$ = new Subject<void>();

  @ViewChild(SettingsComponent) settingsComponent!: SettingsComponent;

  constructor(
    private http: HttpClient,
    private accountInfoService: AccountInfoService
  ) {}
  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  ngOnInit() {
    this.accountInfoService.accountInfo$
      .pipe(takeUntil(this._destroy$))
      .subscribe((data) => {
        this.currentUser = data;
        if (this.currentUser) this.getUserPhoto();
      });
  }

  getUserPhoto(): void {
    const accessToken = this.currentUser!.idToken;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${accessToken}`,
    });

    this.http
      .get('https://graph.microsoft.com/v1.0/me/photo/$value', {
        headers: headers,
        responseType: 'blob', // Specify the response type as blob
      })
      .pipe(takeUntil(this._destroy$))
      .subscribe(
        (blob: Blob) => {
          // Create a URL for the blob and assign it to photoUrl
          this.photoUrl = URL.createObjectURL(blob);
        },
        (error) => {
          console.log('Error fetching user photo:', error);
        }
      );
  }

  openSettings() {
    if (
      this.accountInfoService.checkUserRoles(['Administrator', 'User'], true)
    ) {
      this.settingsComponent.openSettingsModal();
    }
  }
}
